import React, { useEffect } from 'react';
import { LukosAIHero, LukosAIFeatures, LukosAIStrategy } from '../../components/custom/LukosAIPremium/LukosAIPremium';
import { motion } from 'framer-motion';
import { Check, ArrowRight, Sparkles } from 'lucide-react';
import { LukIAMockup } from '../../components/custom/LukosEcommerceShowcase/LukosPlatformMockups';
import '../../components/custom/LukosEcommerceShowcase/LukosEcommerceShowcase.css';


const LukosAIPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white pt-24">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <LukosAIHero />

        {/* Feature 2: Luk IA Interactive Demo */}
        <section className="les-section bg-slate-50 relative pt-20 pb-24 border-b border-slate-200/50 -mt-10">
          <div className="absolute top-10 left-1/2 -translate-x-1/2 bg-violet-600 text-white px-6 py-2 rounded-full font-bold text-xs tracking-widest uppercase shadow-lg shadow-violet-500/30 flex items-center gap-2 z-10">
            <Sparkles size={14} /> Análise Interativa
          </div>
          <div className="les-container relative z-0">
            <div className="les-feature-block reverse">
              <div className="les-content">
                <h3 className="les-title">
                  Sua operação mais inteligente com <span>Luk IA</span>
                </h3>
                <ul className="les-list">
                  <li className="les-item">
                    <Check className="les-icon" size={20} />
                    <span>Cadastre produtos em segundos: a IA identifica NCM, ICMS e categoria automaticamente pela imagem.</span>
                  </li>
                  <li className="les-item">
                    <Check className="les-icon" size={20} />
                    <span>Receba alertas inteligentes de ruptura antes que o estoque acabe e impacte suas vendas.</span>
                  </li>
                  <li className="les-item">
                    <Check className="les-icon" size={20} />
                    <span>Audite taxas de adquirentes e descubra cobranças indevidas com relatório pronto para contestar.</span>
                  </li>
                </ul>
                <a href="#" className="les-cta">
                  Falar com o assistente <ArrowRight size={18} />
                </a>
              </div>

              <div className="les-visual">
                <LukIAMockup />
              </div>
            </div>
          </div>
        </section>

        <LukosAIFeatures />
        <LukosAIStrategy />
        
        <section className="py-20 bg-slate-50 text-center">
          <div className="max-w-4xl mx-auto px-6">
            <h2 className="text-4xl font-black text-slate-900 mb-8" style={{ fontFamily: 'Inter, sans-serif' }}>Pronto para transformar sua gestão?</h2>
            <button className="bg-blue-600 text-white px-10 py-4 rounded-full font-bold text-lg shadow-xl hover:bg-blue-700 transition-all">
              Solicitar apresentação estratégica
            </button>
          </div>
        </section>
      </motion.div>
    </div>
  );
};

export default LukosAIPage;
